import { supabase } from '../supabase';
import {
    listUserGroupsCore,
    createGroupCore,
    findGroupBySlugCore,
    createVaultCore,
    updateGroupCore,
    inviteToGroupCore,
    acceptInviteCore,
    getInviteByTokenCore,
    getInviteOtpForDevCore,
    verifyInviteCodeCore,
    listGroupInvitesCore,
    listGroupContactsCore,
    addContactToGroupCore,
    removeContactFromGroupCore,
    deleteInviteByTokenCore,
    ensureOwnerMembershipCore,
} from '@gv/core';

// Delete an invite from the database by token
export async function deleteInviteByToken(token: string) {
    await deleteInviteByTokenCore(supabase as any, token);
    return true;
}

export type Group = {
    id: string;
    name: string;
    created_by: string;
    created_at: string;
    slug?: string | null;
    plan?: 'personal' | 'family' | 'business';
    // Optional fields if migrations applied
    description?: string | null;
    start_date?: string | null;
    image_url?: string | null;
};

export type GroupMember = {
    group_id: string;
    user_id: string;
    role: 'admin' | 'member' | 'owner';
    created_at: string;
};

export type GroupInvite = {
    id: string;
    group_id: string;
    email: string;
    invited_by: string;
    token: string;
    created_at: string;
};

export async function listUserGroups() {
    return await listUserGroupsCore(supabase as any);
}

export async function createGroup(name: string) { return await createGroupCore(supabase as any, name); }

export async function findGroupBySlug(slug: string) { return await findGroupBySlugCore(supabase as any, slug); }

export async function createVault(slug: string, name?: string) { return await createVaultCore(supabase as any, slug, name); }

export async function updateGroup(id: string, patch: Partial<Pick<Group, 'name' | 'description' | 'start_date' | 'image_url' | 'plan'>>) {
    return await updateGroupCore(supabase as any, id, patch as any);
}

export async function inviteToGroup(groupId: string, email: string, desiredRole?: 'admin' | 'editor' | 'viewer') {
    const role = desiredRole === 'admin' ? 'admin' : 'member';
    return await inviteToGroupCore(supabase as any, groupId, email, role);
}

export async function acceptInvite(token: string) { return await acceptInviteCore(supabase as any, token); }
// Note: custom invite OTP flow removed. We now rely on Supabase Auth emails for login/verification
// and call `accept_group_invite` once the user is authenticated as the invited email.

/**
 * Load invite metadata by token for rendering an accept/decline screen.
 * Returns null if not found. Includes basic vault info when available.
 */
export async function getInviteByToken(token: string) { return await getInviteByTokenCore(supabase as any, token); }

// Removed: listMyInvites (legacy logic)

export async function getInviteOtpForDev(token: string) { return await getInviteOtpForDevCore(supabase as any, token); }

// New: verify invite using manual 6-digit code and ACCEPT the invite in one step
export async function verifyInviteCode(token: string, code: string) { return await verifyInviteCodeCore(supabase as any, token, code); }

// Removed: revokeInvite (legacy logic)

// Removed: revokeInviteByEmail (legacy logic)

// Removed: declineMyInvite (legacy logic)

// Removed: listGroupInvites (legacy logic)
// DB-backed: list active invites for a vault (exclude accepted/revoked/declined)
export async function listGroupInvites(groupId: string) { return await listGroupInvitesCore(supabase as any, groupId) as any; }

// Removed: deleteInvite (legacy logic)

// Removed: purgeOrphanInvites (legacy logic)

export async function listGroupContacts(groupId: string) { return await listGroupContactsCore(supabase as any, groupId); }

export async function addContactToGroup(contactId: string, groupId: string) { return await addContactToGroupCore(supabase as any, contactId, groupId); }

export async function removeContactFromGroup(contactId: string, groupId: string) { return await removeContactFromGroupCore(supabase as any, contactId, groupId); }

export async function ensureOwnerMembership(groupId: string, userId: string) {
    await ensureOwnerMembershipCore(supabase as any, groupId, userId);
}
